export interface ISwiperOptions {
  spaceBetween: number;
  slidesPerView?: number | 'auto';
}

export const PROMOS_SWIPER_OPTIONS: ISwiperOptions = {
  spaceBetween: 10,
  slidesPerView: 1,
};
